module.exports = __webpack_public_path__ + "static/media/img_mapping_01.4e60ed25.png";